import createLucideIcon from '../createLucideIcon';

const Clock1 = createLucideIcon('Clock1', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['polyline', { points: '12 6 12 12 14.5 8', key: '12zbmj' }],
]);

export default Clock1;
